//const url = 'https://api.pecunovus.net';
//const url = 'https://api.hootdex.net';
const url = 'https://mhiservers2.com';
//const url ="${url}/"
//const url = 'http://localhost:8000';

export default url;
